module.exports = __webpack_public_path__ + "media/images/common/select_allow_black-7fb7bed973f51fc235f67d611520b5a5.png";